import type { InferInsertModel, InferSelectModel } from 'drizzle-orm';
import { relations } from 'drizzle-orm';
import {
  boolean,
  index,
  integer,
  pgTable,
  text,
  timestamp,
  uuid,
} from 'drizzle-orm/pg-core';

import { bataillons } from './bataillons';

/**
 * Missões do batalhão (to-do). NOVA tabela.
 * Ordem manual por `position` (0, 1, 2…). Excluir o batalhão apaga as missões (cascade);
 * missão não usa soft delete — é item de lista, não registro de negócio.
 */
/** Quando a missão acontece: antes do retiro, durante (no retiro) ou depois (pós-retiro). */
export const TASK_PHASES = ['before', 'during', 'after'] as const;
export type TaskPhase = (typeof TASK_PHASES)[number];

export const bataillonTasks = pgTable(
  'bataillon_tasks',
  {
    id: uuid('id')
      .primaryKey()
      .$defaultFn(() => Bun.randomUUIDv7()),
    bataillonId: uuid('bataillon_id')
      .notNull()
      .references(() => bataillons.id, { onDelete: 'cascade' }),
    title: text('title').notNull(),
    phase: text('phase').$type<TaskPhase>().notNull().default('before'),
    done: boolean('done').notNull().default(false),
    doneAt: timestamp('done_at'),
    position: integer('position').notNull().default(0),
    createdAt: timestamp('created_at')
      .notNull()
      .$defaultFn(() => new Date()),
    updatedAt: timestamp('updated_at')
      .$onUpdate(() => new Date())
      .notNull(),
  },
  (t) => [index('bataillon_tasks_bataillon_idx').on(t.bataillonId, t.position)],
);

export const bataillonTasksRelations = relations(bataillonTasks, ({ one }) => ({
  bataillon: one(bataillons, {
    fields: [bataillonTasks.bataillonId],
    references: [bataillons.id],
  }),
}));

export type BataillonTask = InferSelectModel<typeof bataillonTasks>;
export type CreateBataillonTaskInput = InferInsertModel<typeof bataillonTasks>;
